import { Component } from '@angular/core';
import { NeighborhoodService } from '../../../../services/neighborhood.service';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-settings-passes-page',
  templateUrl: './settings-passes-page.component.html',
  styleUrl: './settings-passes-page.component.scss'
})
export class SettingsPassesPageComponent {

  constructor(
    public authService: AuthService,
    public neighborhoodService: NeighborhoodService
  ) {}

  update() {
    this.neighborhoodService.update();
  }

  async setProofRequired(
    visitTypeId: string,
    proofTypeId: string,
    status: boolean,
    processWithAi: boolean
  ) {
    this.neighborhoodService.setProofRequired(
      visitTypeId,
      proofTypeId,
      status,
      processWithAi
    );
  }

}
